import dataService from '../../data/data.service';

const state = {
  sessions: []
}

const getters = {
  sessions: (state) => {
    return state.sessions
  }
}

const actions = {
  get(context, params) {
    return new Promise(resolve => {
      dataService.modules.session.get(params).then(data => {
        context.commit('get', data);
        resolve();
      });
    })
  },
}

const mutations = {
  get(state, data) {
    state.sessions = data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}